const DEFAULT_TEXT_COLOR = '#262626'
const DEFAULT_MUTED_TEXT_COLOR = '#3C3C3B'
const DEFAULT_BACKGROUND_COLOR = '#FFFFFF'
const TOOLTIP_VIEWPORT_PADDING = 8
const TOOLTIP_ARROW_WIDTH = 24
const TOOLTIP_ARROW_HEIGHT = 12
const TOOLTIP_ARROW_SEAM_OVERLAP = 1
const TOOLTIP_ARROW_BOTTOM_OFFSET = TOOLTIP_ARROW_HEIGHT - TOOLTIP_ARROW_SEAM_OVERLAP
const TOOLTIP_ARROW_EDGE_PADDING = 20
const TOOLTIP_OFFSET = TOOLTIP_ARROW_BOTTOM_OFFSET + 4
const TOOLTIP_TITLE_FONT_WEIGHT = 500
const TOOLTIP_LABEL_FONT_WEIGHT = 400

const clamp = (value, min, max) => Math.min(Math.max(value, min), max)

export const buildChartTooltip = ({ trigger = 'item', getContent }) => ({
  renderMode: 'html',
  appendToBody: true,
  confine: false,
  trigger,
  backgroundColor: DEFAULT_BACKGROUND_COLOR,
  borderWidth: 0,
  padding: 0,
  className: 'ds-echart-tooltip',
  textStyle: {
    fontFamily: 'Encode Sans',
  },
  extraCssText:
    'box-shadow: 0 16px 32px rgba(0, 0, 0, 0.14); border-radius: 6px; overflow: visible; border: none !important; outline: none;',
  position: (point, _params, dom, _rect, size) => {
    const [pointX, pointY] = point
    const [contentWidth, contentHeight] = size.contentSize
    const [viewWidth, viewHeight] = size.viewSize

    const left = clamp(
      pointX - contentWidth / 2,
      TOOLTIP_VIEWPORT_PADDING,
      viewWidth - contentWidth - TOOLTIP_VIEWPORT_PADDING
    )
    const top = clamp(
      pointY - contentHeight - TOOLTIP_OFFSET,
      TOOLTIP_VIEWPORT_PADDING,
      viewHeight - contentHeight - TOOLTIP_VIEWPORT_PADDING
    )
    const arrowLeft = clamp(pointX - left, TOOLTIP_ARROW_EDGE_PADDING, contentWidth - TOOLTIP_ARROW_EDGE_PADDING)

    dom.style.setProperty('--ds-chart-tooltip-arrow-left', `${arrowLeft}px`)

    return [left, top]
  },
  formatter: (params) => {
    const { title, rows } = getContent(params)

    return [
      '<div style="position: relative; min-width: 164px; font-family: Encode Sans;">',
      `<div style="padding: 16px 16px 4px; color: ${DEFAULT_TEXT_COLOR}; font-size: 14px; font-weight: ${TOOLTIP_TITLE_FONT_WEIGHT}; font-style: normal; line-height: 100%; letter-spacing: 0;">${title}</div>`,
      rows
        .map(({ color, text }, index) =>
          [
            `<div style="display: flex; align-items: center; gap: 8px; padding: ${index === rows.length - 1 ? '4px 16px 14px' : '4px 16px 0'}; color: ${DEFAULT_MUTED_TEXT_COLOR}; font-size: 12px; font-weight: ${TOOLTIP_LABEL_FONT_WEIGHT}; line-height: 15px; letter-spacing: 0.25px;">`,
            color
              ? `<span style="display: inline-block; width: 8px; height: 8px; border-radius: 50%; background: ${color}; flex: 0 0 auto;"></span>`
              : '',
            `<span style="color: ${DEFAULT_MUTED_TEXT_COLOR};">${text}</span>`,
            '</div>',
          ].join('')
        )
        .join(''),
      `<span style="position: absolute; left: var(--ds-chart-tooltip-arrow-left, 50%); bottom: -${TOOLTIP_ARROW_BOTTOM_OFFSET}px; width: ${TOOLTIP_ARROW_WIDTH}px; height: ${TOOLTIP_ARROW_HEIGHT}px; background: #FFFFFF; clip-path: polygon(50% 100%, 0 0, 100% 0); transform: translateX(-50%); border: 0; outline: 0; box-shadow: none; filter: none;"></span>`,
      '</div>',
    ].join('')
  },
})
